module.exports = __webpack_public_path__ + "static/media/layer3M.678ef6ac.png";